// *******************************************************************************
// Mobile menu toggle
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

attachEvent('.hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
const addScrollingClass = () => {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 10);
};

let lastScrollTop = 0;
let ticking = false;

const onScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();

      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.toggle('is-scrolled-up', currentScrollTop < lastScrollTop);

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      ticking = false;
    });
    ticking = true;
  }
};

onScroll();

window.addEventListener('scroll', onScroll);

// To prevent dark mode switch flickering
setTimeout(() => {
  document.documentElement.style.setProperty('--transition-timing', '0.3s');
  document.body.classList.add('load-modes-switch');
}, 100);
